import React from 'react'
import PropTypes from 'prop-types'
import { Card, Button, Form, Input, Empty, Badge, Divider } from 'antd'
import { UserAddOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import DragDropCard from '~/components/dragDropCard'
import Delete from '~/components/deleteConfirm'
import { editTemplateMove } from '~/states/modules/editTemplate'

const StyledCard = styled(Card)`
	margin-bottom: 1.5rem;

	@media (max-width: 768px) {
		margin-bottom: 1rem;
	}
`

const Observers = ({
	observers,
	onAddObserver,
	onUpdateObserver,
	onRemoveObserver,
}) => {
	return (
		<StyledCard title="Observadores">
			{!observers?.length ? (
				<Empty
					description="Sem Observadores"
					style={{ marginBottom: '1.5rem' }}
				/>
			) : (
				observers.map((observer, index) => (
					<DragDropCard
						key={index}
						move={editTemplateMove}
						name="observers"
						index={index}
						listIndex={0}>
						<Form.Item
							name={`observer_name_${index}`}
							label="Nome do Observador"
							onChange={(e) => onUpdateObserver(index, 'name', e.target.value)}
							rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
							initialValue={observer.name}>
							<Input />
						</Form.Item>
						<Form.Item
							name={`observer_email_${index}`}
							label="Email do Observador"
							onChange={(e) => onUpdateObserver(index, 'email', e.target.value)}
							rules={[{ required: true, message: 'Este campo é obrigatório.' }]}
							initialValue={observer.email}>
							<Input />
						</Form.Item>
						<div
							style={{
								display: 'flex',
								background: 'rgba(230, 236, 245, 0.5)',
								height: '40px',
								justifyContent: 'space-evenly',
								alignItems: 'center',
								margin: '25px -25px -10px -25px',
							}}>
							<Badge
								count={index + 1}
								style={{ background: 'var(--ant-primary-color)' }}
							/>
							<Divider
								type="vertical"
								style={{
									height: '20px',
									borderLeft: '1px solid #bdbdbd',
									marginTop: '2px',
								}}
							/>
							<Delete
								handle={() => onRemoveObserver(index)}
								title="Deseja excluir esse observador?"
							/>
						</div>
					</DragDropCard>
				))
			)}
			<Button
				onClick={onAddObserver}
				type="primary"
				icon={<UserAddOutlined />}
				style={{
					display: 'inline-block',
					float: 'right',
				}}>
				Novo Observador
			</Button>
		</StyledCard>
	)
}

Observers.propTypes = {
	observers: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			email: PropTypes.string.isRequired,
		})
	).isRequired,
	onAddObserver: PropTypes.func.isRequired,
	onUpdateObserver: PropTypes.func.isRequired,
	onRemoveObserver: PropTypes.func.isRequired,
}

export default Observers
